/**
 * @generated SignedSource<<9d4746db4a6493423b602736f57ac064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnalysisSimulationViewCatalogQuery$variables = Record<PropertyKey, never>;
export type AnalysisSimulationViewCatalogQuery$data = {
  readonly beachPricingCatalog: ReadonlyArray<{
    readonly bookable: boolean;
    readonly daily: number | null | undefined;
    readonly hourly: number | null | undefined;
    readonly label: string;
    readonly monthly: number | null | undefined;
    readonly monthlyCap: number | null | undefined;
    readonly outboundNetworkTransferPerGigabyte: number | null | undefined;
    readonly percentagePerProject: number | null | undefined;
    readonly platform: string | null | undefined;
    readonly pricePerUnit: number | null | undefined;
    readonly sku: string;
    readonly type: string;
  }>;
};
export type AnalysisSimulationViewCatalogQuery = {
  response: AnalysisSimulationViewCatalogQuery$data;
  variables: AnalysisSimulationViewCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PricingCatalogEntry",
    "kind": "LinkedField",
    "name": "beachPricingCatalog",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sku",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "platform",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthly",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourly",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "daily",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyCap",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentagePerProject",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outboundNetworkTransferPerGigabyte",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricePerUnit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisSimulationViewCatalogQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisSimulationViewCatalogQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c6a40228e1c3c5d26663592e83c01192",
    "id": null,
    "metadata": {},
    "name": "AnalysisSimulationViewCatalogQuery",
    "operationKind": "query",
    "text": "query AnalysisSimulationViewCatalogQuery {\n  beachPricingCatalog {\n    sku\n    label\n    type\n    platform\n    bookable\n    monthly\n    hourly\n    daily\n    monthlyCap\n    percentagePerProject\n    outboundNetworkTransferPerGigabyte\n    pricePerUnit\n  }\n}\n"
  }
};
})();

(node as any).hash = "76dd397fae33cd276f908ee9df10fc99";

export default node;
